<template>
    <router-link :to="{name: 'child.approvals', params: {child_id: notification.data.id}}" class="card p-3 mb-2 diary-likes e3-notification-row">
        <div>
            <span class="font-weight-bold">{{ notification.creator.fname }} {{ notification.creator.lname }} </span>
            <span v-if="showKindergarten"> ({{ notification.kindergarten.name}}) </span>
            <span>{{$t('Notification - Child approvals', {child: data.child_name})}}</span>
        </div>
        <div class="text-muted">
            {{ formatDateTime(notification.created_at) }}
        </div>
    </router-link>
</template>

<script>
import {mapGetters} from 'vuex';
import {formatDateTime} from '@/filters';

export default {
    name: 'ApprovalsSubmitNotification',
    props: {
        notification: Object
    },
    computed: {
        ...mapGetters(['userKindergartens']),
        data() {
            return this.notification.data;
        },
        type() {
            return this.data?.type;
        },
        showKindergarten() {
            return this.notification.kindergarten && this.userKindergartens.length > 1;
        }
    },
    methods: {
        formatDateTime // TODO: Vue3 remove
    }
};
</script>

<style scoped>

</style>
